import { __awaiter, __generator } from "tslib";
import { fetchSiteFeatures } from '../../site-settings';
import { fetchSFCCSetting } from '../../site-settings/fetch-sfcc-setting';
/** Default configuration */
var PRODUCT_CATALOGUE_API_CONFIG = {
    apiKey: '',
    baseUrl: '',
    isSFCCSearchOn: false,
    marketLocale: '',
    sfccLocale: '',
    sfccSearchUrl: '',
};
export var getProductCatalogueApiConfig = function () {
    return PRODUCT_CATALOGUE_API_CONFIG;
};
export var setProductCatalogueApiConfig = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var isSFCCSearchOn, setting, sfccBaseUrl, shopApiLocale;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                PRODUCT_CATALOGUE_API_CONFIG.apiKey = config.apiKey;
                PRODUCT_CATALOGUE_API_CONFIG.baseUrl = config.baseUrl;
                PRODUCT_CATALOGUE_API_CONFIG.marketLocale = config.marketLocale;
                return [4 /*yield*/, fetchSiteFeatures(["SfccSearch" /* SfccSearch */])];
            case 1:
                isSFCCSearchOn = (_a.sent())[0].value;
                PRODUCT_CATALOGUE_API_CONFIG.isSFCCSearchOn = isSFCCSearchOn;
                if (!isSFCCSearchOn) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, fetchSFCCSetting()];
            case 2:
                setting = _a.sent();
                if (setting) {
                    sfccBaseUrl = setting.sfccBaseUrl, shopApiLocale = setting.shopApiLocale;
                    PRODUCT_CATALOGUE_API_CONFIG.sfccLocale = shopApiLocale || config.marketLocale;
                    PRODUCT_CATALOGUE_API_CONFIG.sfccSearchUrl = sfccBaseUrl;
                    if (!sfccBaseUrl) {
                        console.warn('SFCC API URL is not set');
                    }
                }
                else {
                    console.warn('SFCC Search settings are absent');
                }
                return [2 /*return*/];
        }
    });
}); };
